import { memo, useContext } from 'react'
import { useInView } from 'react-intersection-observer'
import styled from 'styled-components'
import { rem } from 'polished'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'
import GeoContext from 'contexts/geoContext'
import { Experiments } from 'constants/optimizely'
import TrustIndicatorSection from 'home/components/TrustIndicatorSection/TrustIndicatorSection'
import cn from 'clsx'
import useExperiment from 'hooks/Optimizely/useExperiment'

const TRUST_INDICATOR_REGIONS = ['SG', 'MY', 'ZA', 'HK'] as const

const Container = styled.div`
  padding: ${rem(16)} 0;
  &.no-gap {
    margin: 0;
    padding: 0;
  }
`

function SearchPageTrustIndicators() {
  const { currentRegionCode } = useContext(GeoContext)
  const isLoggedIn = useAppSelector(selectLoggedIn)
  const [ref, inView] = useInView({ triggerOnce: true })

  const isEmergingMarket = TRUST_INDICATOR_REGIONS.includes(
    currentRegionCode as typeof TRUST_INDICATOR_REGIONS[number],
  )

  const meetsTargetingCriteria = !isLoggedIn || isEmergingMarket

  const { isAnyVariant } = useExperiment(
    Experiments.croTrustIndicatorsSearchPageV2,
    { canActivate: meetsTargetingCriteria && inView },
  )

  const isEnabled = isAnyVariant && meetsTargetingCriteria

  return (
    <Container ref={ref} className={cn({ 'no-gap': !isEnabled })}>
      {isEnabled && <TrustIndicatorSection />}
    </Container>
  )
}

export default memo(SearchPageTrustIndicators)
